import { Component } from 'react';

import { IOC_TYPES } from '../../../context/ioc.types';
import { lazyInject } from '../../../context/module';
import { FileUpload } from '../../../models/file-upload';
import { Logger } from '../../../models/logger';
import { FileManagerService } from '../../../services/file-manager.service';
import { ScriptLoadService } from '../../../services/script-load.service';
import { SpinnerService } from '../../../services/spinner.service';
import { StorageService } from '../../../services/storage.service';
import { UIContext } from '../../../services/ui-context';
import { RouteProps } from '../../../types/route-types';
import { BrowserUtils } from '../../../ui-utils/browser-utils';
import { get, isEqual } from '../../../utils/lodash-min';
import { FileListItemComponent } from './file-list-item.component';
import * as styles from './file-list.component.module.scss'
import { MotiveComponent } from '../motive/motive.component';
import { MotiveLocationTypes } from '../../../utils/request.utils';

interface FileListProps extends RouteProps {
    parentClasses: string;
    cardClasses: string;
    fileUploadArray: FileUpload[];
    sectionTitle;
}

export class FileListComponent extends Component<FileListProps>{
    private readonly logger = Logger.getLogger('FileListComponent');

    extensionInstalled = false;
    showExtension = false;

    // @ViewChildren(FileListItemComponent, {}) fileListItemComponents: QueryList<FileListItemComponent>;

    @lazyInject(IOC_TYPES.SpinnerService) private spinner: SpinnerService;
    @lazyInject(IOC_TYPES.UIContext) private uiContext: UIContext;
    @lazyInject(IOC_TYPES.FileManagerService) private fileManagerService: FileManagerService;
    @lazyInject(IOC_TYPES.ScriptLoadService) private scriptLoadService: ScriptLoadService;
    @lazyInject(IOC_TYPES.StorageService) private storageService: StorageService;

    constructor(props: FileListProps) {
        super(props);
        this.showExtension = isEqual(get(BrowserUtils.getBrowserInfo(), 'name'), 'chrome') && !BrowserUtils.isMobile();
    }

    async downloadAll(fileUploadArray: FileUpload[]) {
        await this.initializeScriptsAndWebsockets();
        this.uiContext.showConfirmationWarningDialog(
            'Download All Files',
            `Are you sure you want to download all files listed on ${this.props.sectionTitle}?
            Note: you may need to enable popups`,
            () => {
                // TODO Preact disabled since not ready
                // this.props.fileListItemComponents.forEach(fileListItemComponent => {
                //     fileListItemComponent.onDownloadBtnHandler(fileListItemComponent.getFileUpload());
                // });
            },
        );
    }

    async clearAllUserData() {
        await this.initializeScriptsAndWebsockets();
        this.uiContext.showConfirmationWarningDialog(
            'Clear All User Data',
            `Are you sure you want to remove all user data and refresh this page?`,
            () => {
                this.storageService.clearAll();
                window.location.reload();
            },
        );
    }

    async removeAll(fileUploadArray: FileUpload[]) {
        await this.initializeScriptsAndWebsockets();
        this.uiContext.showConfirmationWarningDialog(
            'Delete File',
            `Are you sure you want to delete all files listed on ${this.props.sectionTitle}?`,
            async () => {
                for (const fileUpload of fileUploadArray) {
                    await this.fileManagerService.removeFile(fileUpload);
                }
            },
        );
    }

    async initializeScriptsAndWebsockets() {
        await this.spinner.runWithLoader(async () => {
            try {
                await this.scriptLoadService.loadAllScriptsIfNotLoaded();
            } catch (e) {
                this.logger.error({ message: `Something went wrong while loading scripts. ${e.message}`, error: e });
            }
        }, 'Please wait while we initialize file upload service...');
    }

    updateExtensionStatus() {
        this.extensionInstalled = !document.querySelector('.psExtensionLoaded');
    }

    render() {
        return this.props.fileUploadArray && this.props.fileUploadArray.length !== 0 && <div className={`${this.props.parentClasses}`}>

            <div className={styles['section-header']} >
                <h4 className={styles['page-title']}>
                    {this.props.sectionTitle}
                </h4>
                <div className={styles['action-butttons']} >
                    <button className="clear-all x-btn x-btn-sm x-btn-gray x-button-gray-outline" onClick={() => this.clearAllUserData()
                    }>
                        Clear All
                    </button >
                    <button className="delete-all x-btn x-btn-sm x-btn-gray x-button-gray-outline" onClick={() => this.removeAll(this.props.fileUploadArray)}>
                        Delete All
                    </button >

                    {
                        false && <button className="download-all x-btn x-btn-sm x-btn-gray x-button-gray-outline" onClick={() => this.downloadAll(this.props.fileUploadArray)}>
                            Download All
                        </button >
                    }
                    {
                        false && <a className="x-btn x-btn-sm x-btn-primary" target="_blank"
                            href="https://chrome.google.com/webstore/detail/ps2pdf-file-converter/ehcmjgfccokhmdfdecbiejkfbjgkapfn" >
                            Install Chrome Extension
                        </a >
                    }
                </div >
            </div>
            <div className={styles['downloadable-items']} >
                <div className={styles['left-panel']}></div>
                <div className={styles['file-cards']} >
                    {
                        this.props.fileUploadArray.filter((v, idx) => !idx).map(fileUpload => {
                            return <div key={fileUpload.id} className={this.props.cardClasses}>
                                {
                                    !fileUpload.permanentlyDeleted && <FileListItemComponent
                                        {...this.props}
                                        fileUpload={fileUpload}>

                                    </FileListItemComponent>
                                }
                            </div>
                        })
                    }
                    {
                        <div className="gcontent-container">
                            <MotiveComponent
                                data="4411354276" containerWidth="100%" containerHeight="90px"
                                location={MotiveLocationTypes.fileDownloadPageBottom} adWidth="970px" adHeight="90px" showAds={true} className='width_major'
                            ></MotiveComponent>
                        </div>
                    }
                    {
                        this.props.fileUploadArray.filter((v, idx) => idx).map(fileUpload => {
                            return <div key={fileUpload.id} className={this.props.cardClasses}>
                                {
                                    !fileUpload.permanentlyDeleted && <FileListItemComponent
                                        {...this.props}
                                        fileUpload={fileUpload}>

                                    </FileListItemComponent>
                                }
                            </div>
                        })
                    }
                </div >
                <div className={styles['right-panel']}></div>
            </div >
        </div >
    }
}
